import AOS from "aos";
export default class Animate {
  constructor() {
    AOS.init({ duration: 800, once: true, offset: 100 });
  }
}
